import urls from "../urls"
import {callPostApi } from "../callApi"
export type TrendsFeedbackBody = {
  message_id: string;
  feedback: "true" | "false"; // as per curl example
  suggestion?: string;
};

const feedbackService = {
    submitSmileys: (body : unknown) => {
        return callPostApi(urls.FEEDBACK , body)
    },
    submitFeedback: (body : unknown) => {
        return callPostApi(urls.FEEDBACK  , body)
    },

  sendFeedback: (body: TrendsFeedbackBody) => {
    return callPostApi(urls.TRENDS_FEEDBACK, body);
  }
}


export default feedbackService